import React from 'react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import { Surface } from '@americanexpress/dls-react';
import { formatDate } from '../../../utils/abandonCartUtils';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import { clearContextThunk } from '../../../thunks/clearContextThunk';
import { useAccountToken } from '../../../hooks/useMembershipDataHook';

const DismissButton = ({ triggerAnalytics }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const isDesktop = useMediaBreakpoint('lg-up');
  const accountToken = useAccountToken();
  const {
    data: abandonCartData,
    run: reRunContextApi,
  } = useAbandonCartData();
  const {
    tripStartDate,
    tripEndDate,
    hotelProductSelected,
  } = abandonCartData;
  return (
    <button
      id="abandonHotelDismissButton"
      style={{ cursor: 'pointer' }}
      className={clsx('btn btn-sm',
        isDesktop
          ? 'btn-tertiary pad-1 margin-1-l flex flex-justify-center text-align-center'
          : 'btn-white-secondary margin-1 width-full'
      )}
      type="button"
      aria-describedby={
        `${formatMessage({ id: 'abandonHotel.finish' })} ${hotelProductSelected} ${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`
      }
      onClick={(event) => {
        event.stopPropagation();
        triggerAnalytics('dismiss');
        dispatch(clearContextThunk({ reRunContextApi, accountToken }));
      }}
    >
      <Surface variant="fg-brand" className="bg-none width-full">
        <p className={clsx('flex height-full flex-align-center', !isDesktop && 'text-underline')}>
          {formatMessage({ id: 'abandonHotel.dismiss' })}
        </p>
      </Surface>
    </button>
  );
};

DismissButton.propTypes = {
  triggerAnalytics: PropTypes.func.isRequired,
};

export default DismissButton;
